import routerOptions0 from "/Users/szymondziak/StudioProjects/quoteiq-web-nuxt/node_modules/.pnpm/nuxt@3.15.4_@electric-sql+pglite@0.2.17_@parcel+watcher@2.5.1_@types+node@24.0.13_db0@0_8efbc513155d8a7f5859612401e38449/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}